export default __webpack_public_path__ + "6d889f8.png";